import React from 'react';
import { useLoader } from './LoaderContext';


const Loader: React.FC = () => {
  const { isLoading } = useLoader();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black opacity-60"></div>
      <img
        src='/images/Eclipse-1s-150px.svg'
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50"
        alt="Loading"
      />
    </div>
  );
};

export default Loader;
